<template>
    <div>
        <v-row no-gutters class="mb-8">
            <v-col>
                <v-row no-gutters class="pb-2">
                    <v-col cols="2">&nbsp;</v-col>
                    <v-col cols="2"><strong>Last month</strong></v-col>
                    <v-col cols="2"><strong>0-30 days</strong></v-col>
                    <v-col cols="2"><strong>30+ days</strong></v-col>
                    <v-col cols="2"><strong>60+ days</strong></v-col>
                    <v-col cols="2"><strong>90+ days</strong></v-col>
                </v-row>

                <v-row
                    v-for="key in ['leads', 'companies']" :key="key"
                    no-gutters class="pb-2">
                    <v-col cols="2">{{ key }}</v-col>
                    <v-col cols="2" v-for="period in ['last_month', 'thirty_days_ago', 'sixty_days_ago', 'ninety_days_ago']" :key="period">
                        <div v-if="kpi[key] && kpi[key][period]">
                            {{ kpi[key][period].total }} -> {{ kpi[key][period].win }}
                            ({{ myPercent(kpi[key][period].conversion) }})<br>
                            <span v-if="kpi[key][period].total_diff">diff {{ myPercent(kpi[key][period].total_diff) }}</span><br>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters class="mb-4">
            <v-col>
                <v-row no-gutters class="pb-2">
                    <v-col cols="2">&nbsp;</v-col>
                    <v-col cols="2"><strong>Last month</strong></v-col>
                    <v-col cols="2"><strong>0-30 days</strong></v-col>
                    <v-col cols="2"><strong>30+ days</strong></v-col>
                    <v-col cols="2"><strong>60+ days</strong></v-col>
                    <v-col cols="2"><strong>90+ days</strong></v-col>
                </v-row>
                <v-row
                    v-for="key in ['demos']" :key="key"
                    no-gutters class="pb-2">
                    <v-col cols="2">{{ key }}</v-col>
                    <v-col cols="2" v-for="period in ['last_month', 'thirty_days_ago', 'sixty_days_ago', 'ninety_days_ago']"
                           :key="period">
                        <div v-if="kpi[key] && kpi[key][period]">
                            total {{ kpi[key][period].total }}<br>
                            done {{ kpi[key][period].done }}<br>
                            cancelled {{ kpi[key][period].lost }}<br>
                            paid {{ kpi[key][period].win }}
                            ({{ myPercent(kpi[key][period].conversion) }})<br>
                            <span v-if="kpi[key][period].total_diff">diff {{ myPercent(kpi[key][period].total_diff) }}</span><br>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {ref} from "@vue/composition-api"
import errorDialog from "@/views/ErrorDialog/errorDialog"
import AccountModule from "../../store/modules/account"
import {formatPercent} from "../../plugins/formatting";

export default {
    name: "AdminCompany",
    components: {},
    setup() {
        const kpi = ref({})
        const accountModule = AccountModule()

        const copyToClipboard = text => {
            navigator.clipboard.writeText(text)
        }
        const myPercent = val => {
            let x = Math.round(val * 1000) / 1000
            return formatPercent(x)
        }

        const backendQuery = () => {
            let params = {}
            accountModule
                .fetchAdminData('kpi', params)
                .then(function (resp) {
                    kpi.value = resp.kpi
                })
                .catch(function (ex) {
                    errorDialog.showError(ex)
                })
        }
        backendQuery()

        return {
            kpi,
            copyToClipboard,
            formatPercent,
            myPercent,
        }
    }
}
</script>
